<template>
  <div class="condition-group">
    <div class="space-y-4 condition-list">
      <div class="grid grid-cols-2 items-center condition-row">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="checkConfirmationRead"
            v-model="applyToSubFolder.value"
            @input="$emit('saveMeta', { key: 'applyToSubFolder', value: $event.target.checked })"
          >
          <label class="custom-control-label" for="checkConfirmationRead">
            Esta regla aplica a las sub-carpetas
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConditionRenderer from "@/febos/global/rules/components/ConditionRenderer.vue";

export default {
  name: 'MetadataForm',
  components: {ConditionRenderer},
  data() {
    return {
      applyToSubFolder: {
        value: false,
      }
    };
  },
  watch: {
    'ruleState.metadata': function () {
      this.setData();
    }
  },
  methods: {
    setData() {
      const applyToSubFolder = this.ruleState.metadata.find((meta) => meta.key === 'applyToSubFolder');
      if (applyToSubFolder) {
        this.applyToSubFolder.value = applyToSubFolder.value === 'true';
      }
    },
  },
  mounted() {
    this.setData();
  },
  props: {
    ruleState: {
      type: Object
    },
    index: {
      type: Number
    },
    level: {
      type: Number,
      default: 0
    }
  },
}
</script>
